import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface GradientOrColourState {
  showColours: boolean
}

const initialState: GradientOrColourState = {
    showColours: true
}

export const gradientOrColourSlice = createSlice({
  name: 'gradientOrColour',
  initialState,
  reducers: {
    setShowColour: (state) => {
      state.showColours = true;
    },
    setShowGradient: (state) => {
        state.showColours = false;
    },
    toggleGradientOrColourValue: (state) => {
        state.showColours = !state.showColours;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setShowColour, setShowGradient, toggleGradientOrColourValue } = gradientOrColourSlice.actions

export default gradientOrColourSlice.reducer